import script from "./form_media_tv.vue?vue&type=script&setup=true&lang=ts"
export * from "./form_media_tv.vue?vue&type=script&setup=true&lang=ts"

import "./form_media_tv.vue?vue&type=style&index=0&id=02014d3e&scoped=true&lang=css"

import exportComponent from "/home/kuradmin/frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02014d3e"]])

export default __exports__